import { type HTMLAttributes, type ReactNode, forwardRef } from 'react';
import styles from './Card.module.css';

export type CardVariant = 'base' | 'sala' | 'modal';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: CardVariant;
  clickable?: boolean;
  children: ReactNode;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ variant = 'base', clickable = false, children, className, ...rest }, ref) => {
    const classes = [
      styles.card,
      variant !== 'base' && styles[variant],
      clickable && styles.clickable,
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <div
        ref={ref}
        className={classes}
        role={clickable ? 'button' : undefined}
        tabIndex={clickable ? 0 : undefined}
        onKeyDown={
          clickable
            ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  (e.target as HTMLElement).click();
                }
              }
            : undefined
        }
        {...rest}
      >
        {children}
      </div>
    );
  },
);

Card.displayName = 'Card';
